module.exports = __webpack_public_path__ + "img/EtchellsLogo.d5994e7f.png";